import OrderedList from '@tiptap/extension-ordered-list';
export default OrderedList.extend({
  addAttributes() {
    return {
      paddingInlineStart: {
        default: '24px',
        renderHTML: attributes => {
          return {
            style: `padding-inline-start: ${attributes.paddingInlineStart}`
          };
        }
      }
    };
  }
});